import { css } from "@compiled/react";

import Button from "@atlaskit/button";

import { Logo } from "@/libraries/wpl/foundations/src";

import { useLoggedInUser } from "../../utils";

import ArrowCircle from "./assets/arrow-circle";
import Target from "./assets/target";

const HeroSection = () => {
    const loggedInUserName = useLoggedInUser().name;
    // Splitting the name string by a space to separate possible first/last names
    const splitName = loggedInUserName ? loggedInUserName?.split(" ") : [];
    return (
        <section css={jswHeroSectionStyle}>
            <div css={targetStyle}>
                <Target />
            </div>
            <div css={arrowCircleStyle}>
                <ArrowCircle />
            </div>
            <div css={heroTextSectionStyle}>
                <h1 css={headingStyle}>Welcome back, {splitName[0]}.</h1>
                <p css={subHeadingStyle}>
                    Pick up where you left off in Jira Software.
                </p>
                <div css={jiraSiteBoxStyle}>
                    <div css={logoAndSiteNameStyle}>
                        <div css={logoStyle}>
                            <Logo
                                brand="jirasoftware"
                                type="mark"
                                appearance="brand"
                            />
                        </div>
                        <div css={siteStyle}>
                            <div css={productStyle}>Jira Software</div>
                            <div css={siteNameStyle}>
                                myreallyawesomesitenamemyreallyawesomesitenamemyre
                            </div>
                        </div>
                    </div>
                    <Button
                        id="jira-button"
                        appearance="warning"
                        href="#"
                        css={buttonStyle}
                    >
                        Go to Jira
                    </Button>
                </div>
                <div css={otherJiraSiteStyle}>
                    I’m looking for another Jira site
                </div>
            </div>
        </section>
    );
};

const jswHeroSectionStyle = css({
    backgroundImage: "linear-gradient(180deg, #253858 0%, #091E42 100%)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 15px"
});

const targetStyle = css({
    "position": "absolute",
    "insetInlineStart": "0",
    "insetBlockStart": "0",
    "@media (max-width: 1000px)": {
        display: "none"
    }
});

const arrowCircleStyle = css({
    "position": "absolute",
    "insetInlineEnd": "0",
    "insetBlockStart": "250px",
    "@media (max-width: 1000px)": {
        display: "none"
    }
});

const heroTextSectionStyle = css({
    "color": "white",
    "width": "100%",
    "maxWidth": "928px",
    "margin": "100px 170px 50px 170px",
    "p": {
        fontSize: "20px",
        lineHeight: "28px",
        fontWeight: "400"
    },
    "@media (max-width: 1000px)": {
        margin: "100px 15px 50px 15px"
    }
});

const jiraSiteBoxStyle = css({
    width: "100%",
    height: "72px",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    border: "2px solid #579DFF",
    padding: "10px 10px",
    marginBlockStart: "20px",
    marginBlockEnd: "20px"
});

const headingStyle = css({
    fontSize: "48px",
    lineHeight: "56px",
    fontWeight: "500",
    marginBlockEnd: "15px"
});

const siteStyle = css({
    lineHeight: "22px",
    fontSize: "16px",
    overflow: "hidden"
});

const productStyle = css({ fontWeight: "600px" });

const siteNameStyle = css({
    fontWeight: "400px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
});

const buttonStyle = css({
    marginInlineStart: "15px"
});

const otherJiraSiteStyle = css({
    marginBlockStart: "15px",
    fontSize: "16px",
    textDecoration: "underline"
});

const subHeadingStyle = css({
    marginBlockStart: "15px",
    marginBlockEnd: "15px"
});

const logoStyle = css({
    marginInlineEnd: "10px",
    marginBlockStart: "9px"
});

const logoAndSiteNameStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minWidth: "0px"
});

export default HeroSection;
